/**
 * media/products/no_image.jpg is a real file on disk (same convention as
 * product-card.blade.php's ProductImageHelper::isNoImageUrl()), so any CSR
 * image-URL resolution must exclude it explicitly — otherwise it loads
 * successfully, <img onerror> never fires, and the no-image placeholder
 * never gets a chance to show.
 */
export function isDefaultNoImagePath(candidate: string): boolean {
    const normalized = candidate
        .replace(/^https?:\/\/[^/]+/i, "")
        .split("?")[0]
        .split("#")[0]
        .replace(/^\/+/, "")
        .replace(/\\/g, "/")
        .toLowerCase();
    return normalized === "media/products/no_image.jpg";
}
